import Vue from 'vue'
import Router from 'vue-router'

import Startpage from './views/Startpage.vue';
import Searchresults    from './views/Searchresults.vue';
import Entry    from './views/Entry.vue';
import Page    from './views/Page.vue';
import Dashboard    from './views/Dashboard.vue';
import Editor    from './views/Editor.vue';
import Profile    from './views/Profile.vue';
import Account    from './views/Account.vue';
import Errorpage from './views/Errorpage.vue';


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  /*scrollBehavior (to, from, savedPosition) {
    return false;
  },*/
  routes: [
    {
      path: '/:mode(extended)?',
      name: 'home',
      components: {
        content: Startpage
      }
    },    
    {
      path: '/profile',
      name: 'profile',
      components: {
        content: Profile
      }
    },
    {
      path: '/account',
      name: 'account',
      components: {
        content: Account
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        content: Dashboard
      }
    },        
    {
      path: '/dashboard/:editor(SecondaryLiterature|Book|Media)/:id(\\d+)',
      name: 'editor',
      components: {
        content: Editor
      }
    },            
    {
      path: '/forgot',
      name: 'forgot',
      components: {
        content: Startpage
      }
    },
    {
      path: '/Search',
      name: 'searchresults',
      components: {
        content: Searchresults
      }
    },
    {
      path: '/Page/:id(\\d+)/:name',
      name: 'page',
      components: {
        content: Page
      }
    },
    {
      path: '/:view(SecondaryLiterature|Book|Media|Person)/:id(\\d+)',
      name: 'entry',
      components: {
        content: Entry
      }
    },
    {
      path: '*',
      name: 'error',
      components: {
        content: Errorpage
      }
    }
  ]
})


router.beforeEach((to, from, next) => {
  document.title = `Lexikon ADS`;
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  return next();    
})

export default router